import {Injectable} from '@angular/core';
import {IdCodeNameModel, MesApiService} from "common-shared";
import {map} from "rxjs/operators";
import {plainToInstance} from "class-transformer";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService extends MesApiService {

  constructor() {
    super('GlobalSearch');
  }

  get(searchString: string): Observable<GlobalSearchResultModel[]> {
    return this.getList<GlobalSearchResultModel[]>({action: 'Get'}, {searchString: searchString}).pipe(map(value => {
      return plainToInstance(GlobalSearchResultModel, value.data);
    }));
  }
}

export class GlobalSearchResultModel extends IdCodeNameModel {
  constructor(init?: Partial<GlobalSearchResultModel>) {
    super();
    Object.assign(this, init);
  }

  public Type: number;
  public IsDraft: boolean;
  public Value: string;
  public IsActive: boolean;
}

export class GlobalSearchResultGroupModel {
  constructor(init?: Partial<GlobalSearchResultGroupModel>) {
    Object.assign(this, init);
  }
  public Name: string;
  public Type: number;
  public Results: GlobalSearchResultModel[] = [];
  public CssClass: string;
  public Length: number;
  public IsCollapsed: boolean;
  public IsActive?: boolean;
}
